/* Progressive loading for the existing collection grid and its active filters. */
(() => {
  if (!/\/collections(?:\/|$)/.test(location.pathname)) return;
  const prepared = new WeakSet();
  const nextLink = root => root.querySelector('.pagination__next-control a, .pagination a[aria-label="Page suivante"], .pagination a[rel="next"]');
  function prepare() {
    const grid = document.querySelector('#product-grid');
    const wrapper = document.querySelector('#ProductGridContainer .pagination-wrapper');
    if (!grid || !wrapper || prepared.has(wrapper)) return;
    prepared.add(wrapper);
    let next = nextLink(wrapper)?.getAttribute('href');
    wrapper.classList.add('local-pagination-ready');
    if (!next) { wrapper.hidden = true; return; }
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'local-load-more'; button.textContent = 'Voir plus';
    button.setAttribute('aria-controls', 'product-grid');
    const status = document.createElement('p');
    status.className = 'local-load-status visually-hidden';
    status.setAttribute('role', 'status');
    wrapper.append(button, status);
    button.addEventListener('click', async () => {
      if (button.disabled || !next) return;
      const context = location.pathname + location.search;
      const url = new URL(next, location.origin);
      if (url.origin !== location.origin || url.pathname !== location.pathname) return;
      button.disabled = true; button.textContent = 'Chargement…';
      wrapper.setAttribute('aria-busy', 'true');
      status.classList.add('visually-hidden'); status.textContent = '';
      try {
        const response = await fetch(url.href);
        if (!response.ok) throw new Error('Collection unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!wrapper.isConnected || document.querySelector('#product-grid') !== grid || context !== location.pathname + location.search) return;
        const incoming = [...page.querySelectorAll('#product-grid > .grid__item')];
        if (!incoming.length) throw new Error('Missing product grid');
        const ids = new Set([...grid.children].map(e => e.dataset.cabaneProductId).filter(Boolean));
        const added = incoming.filter(e => !e.dataset.cabaneProductId || !ids.has(e.dataset.cabaneProductId));
        if (!added.length) throw new Error('No new products');
        const y = window.scrollY;
        added.forEach(card => {
          // These cards are inserted after the theme's initial scroll observer.
          card.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          grid.append(document.importNode(card, true));
        });
        next = nextLink(page)?.getAttribute('href');
        button.hidden = !next;
        status.textContent = `${added.length} produits supplémentaires affichés.${next ? '' : ' Tous les produits sont affichés.'}`;
        grid.children[grid.children.length - added.length]?.querySelector('.card__heading a')?.focus({preventScroll:true});
        window.scrollTo({top:y, behavior:'instant'});
      } catch (_) {
        if (!wrapper.isConnected) return;
        status.classList.remove('visually-hidden');
        status.textContent = 'Le chargement a échoué. Réessaie avec « Voir plus ».';
      } finally {
        button.disabled = false; button.textContent = 'Voir plus';
        wrapper.removeAttribute('aria-busy');
      }
    });
  }
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; prepare(); });
  };
  prepare();
  const root = document.querySelector('#MainContent');
  if (root) new MutationObserver(schedule).observe(root, {childList:true, subtree:true});
})();
